export const switchToQuickBooksReasons = [
  'Missing features I need',
  'Pricing / rates',
  'Prefer QuickBooks workflow',
  'Payment processing issues',
  'Not ready to switch fully',
  'Team resistance to change',
  'Bank/deposit timing concerns',
  'Other',
] as const

export type SwitchToQuickBooksReason = typeof switchToQuickBooksReasons[number]

export const showTellUsMore = (reason: SwitchToQuickBooksReason | null): boolean => {
  return reason === 'Other'
}

export const getConfirmDetails = (reason: SwitchToQuickBooksReason, details: string): string | undefined => {
  if (!showTellUsMore(reason)) {
    return undefined
  }
  const trimmed = details.trim()
  if (trimmed === '') {
    return undefined
  }
  return trimmed
}
